var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteTwitterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5625 29C22.5706 29 29.0625 22.5081 29.0625 14.5C29.0625 6.49187 22.5706 0 14.5625 0C6.55437 0 0.0625 6.49187 0.0625 14.5C0.0625 22.5081 6.55437 29 14.5625 29ZM24.0273 9.69531C23.5352 10.4336 22.9023 11.0664 22.1992 11.5938V12.0859C22.1992 16.9727 18.5078 22.5625 11.7227 22.5625C9.61328 22.5625 7.67969 21.9648 6.0625 20.9102C6.34375 20.9453 6.625 20.9805 6.94141 20.9805C8.66406 20.9805 10.2461 20.3828 11.5117 19.3984C9.89453 19.3633 8.52344 18.3086 8.06641 16.832C8.0941 16.836 8.12134 16.8399 8.14824 16.8438C8.36041 16.8747 8.55113 16.9023 8.76953 16.9023C9.08594 16.9023 9.4375 16.832 9.71875 16.7617C8.03125 16.4102 6.76562 14.9336 6.76562 13.1406V13.1055C7.25781 13.3867 7.85547 13.5273 8.45312 13.5625C7.43359 12.8945 6.80078 11.7695 6.80078 10.5039C6.80078 9.80078 6.97656 9.16797 7.29297 8.64062C9.12109 10.8555 11.8633 12.332 14.9219 12.5078C14.8516 12.2266 14.8164 11.9453 14.8164 11.6641C14.8164 9.625 16.4688 7.97266 18.5078 7.97266C19.5625 7.97266 20.5117 8.39453 21.2148 9.13281C22.0234 8.95703 22.832 8.64062 23.5352 8.21875C23.2539 9.09766 22.6914 9.80078 21.918 10.2578C22.6562 10.1875 23.3945 9.97656 24.0273 9.69531Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteTwitterLogo);
export default __webpack_public_path__ + "static/media/white-twitter-logo.df2a51d1091aa314ce1c8f9bca1ca65c.svg";
export { ForwardRef as ReactComponent };